import React from 'react';
import { connect } from 'react-redux';
import { Provider } from '../../common/ComponentIdContext';
import { ComponentNameProvider } from '../../common/ComponentNameContext';
import ConstCommon from '../../common/Const';
import Tab from '../../common/tab/Tab';
import TabContent from './TabContent';
import './STRanking.scss';
import ScrollComponent from '../../common/ScrollComponent';
import Footer from './common/Footer';
import { REDUCER_NAME, changeTabContent } from './reducer';
import { compose } from 'redux';
import PreRender from './../../common/PreRender';
import { changeIdHover } from './reducer';

class STRanking extends React.Component {
  constructor(props) {
    super(props);
    const { changeTabContent, tab } = this.props;
    if (tab) {
      changeTabContent(tab);
    }
  }

  changeTab = currentTab => {
    const { changeTabContent } = this.props;
    changeTabContent(currentTab);
    const { changeIdHover } = this.props;
    changeIdHover({});
  };

  render() {
    const { currentTab, id } = this.props;

    return (
      <PreRender {...this.props}>
        <Provider value={id}>
          <ComponentNameProvider value={ConstCommon.listComponent.STRanking}>
            <ScrollComponent>
              <div className="px-20 pt-8 st_ranking h-100 d-flex flex-column">
                <div className="top-nav d-flex flex-column flex-fill">
                  <Tab
                    currentTab={currentTab}
                    listTab="stRanking.tabs"
                    changeTab={this.changeTab}
                  />
                  <div
                    style={{ minHeight: 220 }}
                    className="tab-content tab-content-st-ranking flex-fill d-flex flex-column h-auto"
                  >
                    <TabContent currentTab={currentTab} />
                  </div>
                  <Footer currentTab={currentTab} />
                </div>
              </div>
            </ScrollComponent>
          </ComponentNameProvider>
        </Provider>
      </PreRender>
    );
  }
}

const mapStateToProps = state => ({
  i18n: state.i18n,
  currentTab: state[REDUCER_NAME].currentTab,
});

const mapDispatchToProps = {
  changeTabContent,
  changeIdHover,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(STRanking);
